import { dispatch } from './store';
import { rebrand2022Theme } from './themes/rebrand2022/rebrand2022';

export const useRebrand2022Theme = ({ persist = true }) =>
  dispatch('useTheme', rebrand2022Theme.name, persist);
